import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"margin":"0 30px","font-size":"17px","border":"0","word-wrap":"break-word","color":"black","text-align":"left"} }
const _hoisted_2 = ["href"]
const _hoisted_3 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_4 = { style: {"padding":"35px 0 10px 50px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"20px"} }, "Select your submission type", -1)
const _hoisted_6 = { style: {"text-align":"left"} }
const _hoisted_7 = {
  key: 0,
  class: "holly-section"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"20px"} }, "Select the method type you proposed", -1)
const _hoisted_9 = { style: {"margin":"0 0 20px 0","text-align":"left"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"20px"} }, "Input the name of your algorithm", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"20px","margin":"20px 0 10px 0"} }, "Provide statistics", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"20px","margin":"20px 0 10px 0"} }, "Provide other information", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_16 = {
  key: 1,
  class: "holly-section"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"20px","margin":"0 0 10px 0"} }, "Give us suggestions", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { style: {"display":"flex","justify-content":"center"} }

import { UploadFilled } from '@element-plus/icons-vue'
import {ElMessage, UploadInstance, UploadProps} from "element-plus";
import { ref } from 'vue';
import axios from "axios";
import {useStore} from "vuex";
import request from "@/api";
import {router} from "@/router";

// 使用ref创建一个变量，用于记录已上传的文件

export default /*#__PURE__*/_defineComponent({
  __name: 'submission',
  setup(__props) {

const uploadRef = ref<UploadInstance>();
const uploadRef2 = ref<UploadInstance>();
const uploadRef3 = ref<UploadInstance>();
const uploadFileList = ref([]);
const uploadFileList2 = ref([]);
const uploadFileList3 = ref([]);
const store = useStore();
const userQuery = ref('')
const Email = ref('')
const Infos = ref('')
const morf = ref('')
const lerf = ref('')
const pythonValue = ref('')
const servers = ref([])
const servers2 = ref([])
const currentPage = ref(1)
const currentPage2 = ref(1)
const perPage = ref(8)
// const perPage2 = ref(8)
const score = ref(0.0)
const rank = ref(666)
let resultLoading = ref(false)
let resultShow = ref(false)
const morfUploaded = ref(false)
const lerfUploaded = ref(false)
const pythonUploaded = ref(false)
const ConfirmVisible = ref(false)
// const lerfUploaded = ref(false)
let checkCsv = ref(false)
let checkCsv2 = ref(false)
let checkPython = ref(false)

const currentType = ref('suggestion')

const isLeaderBoard = ref("suggestion")

const methodType = ref("importance")

const algoName = ref("")


const style = ref({
  pagination: {
    marginTop: '20px'
  },
  down: {
    marginBottom: '20px'
  }
})


const fields = ref([
  {
    key: 'ranking',
    label: 'Ranking',
    class: 'text-center'
  },
  {
    key: 'username',
    label: 'contributor',
    sortable: true,
    class: 'text-center'
  },
  {
    key: 'institute',
    label: 'institute',
    sortable: true,
    class: 'text-center'
  },
  {
    key: 'name',
    label: 'algorithm',
    class: 'text-center'
  },
  {
    key: 'score',
    label: 'metascore',
    stickyColumn: true,
    class: 'text-center'
  }
])

function checkFile(file) {
  const isCSV = file.type === 'text/csv';
  const isSizeValid = file.size / 1024 <= 500; // Convert size from bytes to kilobytes
  if (!isCSV) {
    ElMessage.error('Please upload a CSV file.')
  }
  if (!isSizeValid) {
    ElMessage.error('Please upload a CSV file with a size less than 500KB.')
  }
  checkCsv.value = isCSV && isSizeValid;
  return isCSV && isSizeValid;
}

function checkFile2(file) {
  const isCSV = file.type === 'text/csv';
  const isSizeValid = file.size / 1024 <= 500; // Convert size from bytes to kilobytes
  if (!isCSV) {
    ElMessage.error('Please upload a CSV file.')
  }
  if (!isSizeValid) {
    ElMessage.error('Please upload a CSV file with a size less than 500KB.')
  }
  checkCsv2.value = isCSV && isSizeValid;
  return isCSV && isSizeValid;
}

function checkFilePython(file) {
  const isPy = file.name.toLowerCase().endsWith('.py');
  const isSizeValid = file.size / 1024 <= 500; // Convert size from bytes to kilobytes
  if (!isPy) {
    ElMessage.error('Please upload a python file.')
  }
  if (!isSizeValid) {
    ElMessage.error('Please upload a python file with a size less than 500KB.')
  }
  checkPython.value = isPy && isSizeValid;
  return isPy && isSizeValid;
}

const resetSetting = (type) => {
  ConfirmVisible.value = false
  isLeaderBoard.value = type
  currentType.value = type
}

// const toLeader = () => {
//   ConfirmVisible.value = false
//   isLeaderBoard.value = "leaderboard"
// }

const handleLeaderboardClick = () => {
  ConfirmVisible.value = true
  // isLeaderBoard.value = "leaderboard"
  // Perform your check or validation here
  // If successful, change to "leaderboard"


  // if (/* Your validation condition */) {
  //   this.isLeaderBoard = 'leaderboard';
  // } else {
  //   // Handle the case when the validation fails
  //   // You can show an error message or take appropriate action
  //   console.log('Validation failed. Do not switch to leaderboard.');
  // }
}




// function handleUploadSuccess(response) {
//   ElMessage.success('File uploaded successfully.')
// }
//
// function handleUploadError(err) {
//   ElMessage.error('File upload failed.')
// }

// const handleRemove: UploadProps["onRemove"] = (uploadFile, uploadFiles) => {
//   // console.log(uploadFileList);
//   // const index=uploadFileList.value.findIndex((e)=>{return e===uploadFile})
//   console.log(uploadFile, uploadFiles);
// };
// const handlePictureCardPreview: UploadProps["onPreview"] = (uploadFile) => {
//   dialogImageUrl.value = uploadFile.url!;
//   dialogVisible.value = true;
//   // console.log("dialogImageUrl.value: ", dialogImageUrl.value)
// };
const handleChange1: UploadProps["onChange"] = (file, fileList) => {
  uploadFileList.value = fileList;
  console.log("uploadFileList.value:", uploadFileList.value)
  console.log("checkCsv.value: ", checkCsv.value)
  if(checkCsv.value){
    uploadCsv('morf')
  }
};
const handleChange2: UploadProps["onChange"] = (file, fileList) => {
  uploadFileList2.value = fileList;
  console.log("uploadFileList2.value:", uploadFileList2.value)
  console.log("checkCsv2.value: ", checkCsv2.value)
  if(checkCsv2.value){
    uploadCsv('lerf')
  }
};
const handleChange3: UploadProps["onChange"] = (file, fileList) => {
  uploadFileList3.value = fileList;
  console.log("uploadFileList3.value:", uploadFileList3.value)
  console.log("checkPython.value: ", checkPython.value)
  if(checkPython.value){
    uploadPython()
  }
};
async function uploadCsv(type){
  let param = new FormData();
  if(type=='morf'){
    console.log("uploadFileList: ", uploadFileList);
    uploadFileList.value.forEach(
        (val, index) => {
          param.append("pictures", val.raw);
          console.log("test", val.raw);
        }
    );
  }else if(type=='lerf'){
    console.log("uploadFileList2: ", uploadFileList2);
    uploadFileList2.value.forEach(
        (val, index) => {
          param.append("pictures", val.raw);
          console.log("test", val.raw);
        }
    );
  }
  console.log("datasetId: ", store.state.datasetId);
  param.append("datasetId", store.state.datasetId);
  let config = {
    baseURL: "/api",
    //baseURL: "http://localhost:7667",
    timeout: 30000,
    headers: {
      "Content-Type": "multipart/form-data" //设置headers
    }
  };
  console.log("param: ", param);
  await axios
      .post("/data/uploadCsvs", param, config)
      .then(res => {
        console.log("res: ", res);
        if (res.status === 200) {
          console.log("yes");
          if(type=='morf'){
            let arr = res.data.data.imgpath.split("/")
            morf.value = arr[arr.length - 1]
            console.log("morf.value: ", morf.value);
            uploadRef.value.clearFiles();
            uploadFileList.value = [];
            morfUploaded.value = true;
            ElMessage.success('Morf file uploaded successfully.')
          }else if(type=='lerf'){
            let arr = res.data.data.imgpath.split("/")
            lerf.value = arr[arr.length - 1]
            console.log("lerf.value: ", lerf.value);
            uploadRef2.value.clearFiles();
            uploadFileList2.value = [];
            lerfUploaded.value = true;
            ElMessage.success('Lerf file uploaded successfully.')
          }
        }else{
          ElMessage.error('File upload failed.')
        }
      })
      .catch(err => {
        console.log(err);
      });
  // console.log("uploadFileList: ", uploadFileList);
}

async function uploadPython(){
  let param = new FormData();
  console.log("uploadFileList3: ", uploadFileList3);
  uploadFileList3.value.forEach(
      (val, index) => {
        param.append("pictures", val.raw);
        console.log("test", val.raw);
      }
  );
  console.log("datasetId: ", store.state.datasetId);
  param.append("datasetId", store.state.datasetId);
  let config = {
    baseURL: "/api",
    //baseURL: "http://localhost:7667",
    timeout: 30000,
    headers: {
      "Content-Type": "multipart/form-data" //设置headers
    }
  };
  console.log("param: ", param);
  await axios
      .post("/data/uploadCsvs", param, config)
      .then(res => {
        console.log("res: ", res);
        if (res.status === 200) {
          console.log("yes");
          let arr = res.data.data.imgpath.split("/")
          pythonValue.value = arr[arr.length - 1]
          console.log("pythonValue.value: ", pythonValue.value);
          uploadRef3.value.clearFiles();
          uploadFileList3.value = [];
          pythonUploaded.value = true;
          ElMessage.success('File uploaded successfully.')
        }else{
          ElMessage.error('File upload failed.')
        }
      })
      .catch(err => {
        console.log(err);
      });
}


async function getUsrRank(){
  if(userQuery.value === ''){
    ElMessage.error('Please input the name of your attribution algorithm!')
  }else if(morfUploaded.value == false){
    ElMessage.error('Please upload your morf result!')
  }else if(lerfUploaded.value == false){
    ElMessage.error('Please upload your lerf result!')
  }else{
    ElMessage.success('Information complete, processing......')
    resultLoading.value = true
    await axios
        .post(`/user/getUsrRank`, {
        })
        .then((response) => {
          let ranks = response.data.data.ranklistinfo
          console.log("response.data.data", response.data.data)
          console.log("ranks: ", ranks)
          servers.value = ranks
        })
        .catch((errors) => {
          console.log('error', errors)
        })

    let temp = {
      morfpath: "/nfs3-p1/duanjr/meta-score-attribution-hollylee/data/user_upload/" + morf.value,
      lerfpath: "/nfs3-p1/duanjr/meta-score-attribution-hollylee/data/user_upload/" + lerf.value,
    };
    console.log("请求体：", temp);
    await axios
        .post(`/user/getUsrRank2`, temp)
        .then((response) => {
          let ranks = response.data.data.ranklistinfo
          console.log("response.data.data", response.data.data)
          console.log("ranks: ", ranks)
          servers2.value = ranks
          for (let i = 0; i < servers2.value.length; i++) {
            // const element = servers2.value[i];
            // 检查username是否为"The User"
            if (servers2.value[i].username === "The User") {
              // 如果是，则修改contributor、institute和algorithm字段
              servers2.value[i].username = store.state.username;
              servers2.value[i].institute = store.state.institute;
              servers2.value[i].name = userQuery.value;

              score.value = servers2.value[i].score;
              rank.value = servers2.value[i].ranking;
            }
          }

        })
        .catch((errors) => {
          console.log('error', errors)
        })

    resultShow.value = true
    resultLoading.value = false
  }
}


async function SubmitAlgorithm(){
  // if()

  if(isLeaderBoard.value === 'suggestion'){
    if(Infos.value == ''){
      ElMessage.error('Input something!')
      return
    }
  }else{
    if(userQuery.value === ''){
      ElMessage.error('Input the name of your algorithm!')
      return
    }else if(Email.value == ''){
      ElMessage.error('Provide statistics about your algorithm!')
      return
    }else if(Infos.value == ''){
      ElMessage.error('Please complete information about your algorithm!')
      return
    }

  }

  ElMessage.success('Information complete, submitting your suggestion/algorithm......')
  resultLoading.value = true
  let temp1 = {
    username: store.state.username,
    name: userQuery.value,
    score: score.value,
    institute: store.state.institute,
    ranking: rank.value,
    morfPath: isLeaderBoard.value,
    lerfPath: methodType.value,
    pythonPath: "pythonPath",
    email: Email.value,
    info: Infos.value,
  };
  console.log("temp1: ", temp1)
  await request.post(`/user/SubmitAlgorithm`, temp1)
      .then((response) => {
        console.log("response: ", response)
        if (response.status === 200 && response.data.code===0){
          ElMessage.success('Submission success!')
        }else{
          ElMessage.error('Submission failed!')
        }
      })
      .catch((errors) => {
        // console.log("temp1: ", temp1)
        ElMessage.success('Submission failed!')
        console.log('error', errors)
      })
  // resultShow.value = true
  resultLoading.value = false
  userQuery.value = ''
  Email.value = ''
  Infos.value = ''



  // else{
  //   if(pythonUploaded.value === true){
  //     ElMessage.success('You choose to submit your algorithm file.')
  //   }else{
  //     ElMessage.warning('You choose not to submit your algorithm file.')
  //   }
  //   ElMessage.success('Information complete, submitting your algorithm......')
  //
  // }
}

function DetermineUser() {
  console.log("确认用户信息")
  console.log("权限: ", store.state.access)
  let temp = {
    username: store.state.username,
    password: 23333,
  };
  console.log(temp);
  request
      .post("/user/findNoPass", temp)
      .then((res) => {
        console.log(res)
        if (res.status === 200) {
          console.log("确认成功")
          const userInfo = res.data.data.userInfo
          store.commit('setInstitute', userInfo.institute)
          console.log("userInfo.institute: ", userInfo.institute)
          console.log("store.state.institute: ", store.state.institute)
        } else{
          console.log("确认失败")
        }
      })
      .catch((err) => {
        console.log((err));
      });

}

DetermineUser()
// ();
// defineExpose({DetermineUser})
// export { DetermineUser };

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      class: "scrollable",
      modelValue: ConfirmVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ConfirmVisible).value = $event)),
      style: {"width":"50%","height":"60%","text-align":"center","overflow":"auto","font-family":"Arial"},
      draggable: true,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (resetSetting(currentType.value))),
      "append-to-body": true,
      title: "Confirm - Submit an algorithm"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_1, [
            _createTextVNode(" Confirm that you have implemented the interface for your pruning algorithm using our Python library: "),
            _createElementVNode("a", {
              href: 'https://github.com/HollyLee2000/PruningBench',
              target: "_blank"
            }, "https://github.com/HollyLee2000/PruningBench", 8, _hoisted_2),
            _createTextVNode(", and have submitted a pull request to the project. Only after these can we include your algorithm in our leaderboard. Due to the necessary experimental validation for your algorithm, your request may take some time to receive a response. You can contact us via email at hollylee@zju.edu.cn. ")
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            size: "large",
            style: {"margin":"50px 40px 10px 0"},
            type: "info",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (resetSetting('suggestion'))),
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            size: "large",
            style: {"margin":"50px 40px 10px 0"},
            type: "success",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (resetSetting('leaderboard'))),
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Confirm")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_radio_group, {
          style: {"margin":"10px 0 0 0","border":"0","color":"black"},
          modelValue: isLeaderBoard.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isLeaderBoard).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, {
              label: "suggestion",
              size: "large",
              border: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("Submit a suggestion/bug/issue")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio, {
              label: "leaderboard",
              size: "large",
              border: "",
              onClick: handleLeaderboardClick
            }, {
              default: _withCtx(() => [
                _createTextVNode("Submit a pruning algorithm to the leaderboard")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    (isLeaderBoard.value==='leaderboard')
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_radio_group, {
              style: {"margin":"10px 0 20px 0","border":"0","color":"black"},
              modelValue: methodType.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((methodType).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "Importance",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Importance")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "Regularizer",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Regularizer")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "Importance + Regularizer",
                  size: "large",
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Both")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _hoisted_10,
          _createVNode(_component_el_input, {
            modelValue: userQuery.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((userQuery).value = $event)),
            style: {"width":"300px","margin":"10px 0 20px 0"},
            rows: 1,
            type: "textarea"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", null, [
            _hoisted_11,
            _createTextVNode(" Provide available results or a link to your paper (recommended). We will conduct experiments for your method and incorporate the results into the leaderboards. Therefore, having existing experimental results would serve as a valuable reference. "),
            _hoisted_12,
            _createVNode(_component_el_input, {
              modelValue: Email.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((Email).value = $event)),
              style: {"margin":"10px 0 0 0"},
              rows: 3,
              type: "textarea"
            }, null, 8, ["modelValue"]),
            _hoisted_13,
            _createTextVNode(" Furnish further details about your algorithm so that we can incorporate this information into the \"Notice\" column of the leaderboards. "),
            _hoisted_14,
            _createVNode(_component_el_input, {
              modelValue: Infos.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((Infos).value = $event)),
              style: {"margin":"10px 0 0 0"},
              rows: 3,
              type: "textarea"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_button, {
                size: "large",
                style: {"margin":"50px 0 10px 0"},
                type: "success",
                onClick: SubmitAlgorithm,
                plain: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Submit your algorithm")
                ]),
                _: 1
              })
            ])
          ])
        ])), [
          [_directive_loading, _unref(resultLoading)]
        ])
      : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", null, [
            _hoisted_17,
            _createTextVNode(" We welcome your suggestions regarding various aspects of our work, including the design of the leaderboard, any bugs or issues encountered while using the website, and more. Alternatively, you can contact us directly via email at hollylee@zju.edu.cn. "),
            _hoisted_18,
            _createVNode(_component_el_input, {
              modelValue: Infos.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((Infos).value = $event)),
              style: {"margin":"10px 0 0 0"},
              rows: 3,
              type: "textarea"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_el_button, {
                size: "large",
                style: {"margin":"50px 0 10px 0"},
                type: "success",
                onClick: SubmitAlgorithm,
                plain: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Submit your suggestions")
                ]),
                _: 1
              })
            ])
          ])
        ])), [
          [_directive_loading, _unref(resultLoading)]
        ])
  ], 64))
}
}

})